export const API_PATH = '/api/backend/';
export const BACKEND_BASE_URL = process.env.REACT_APP_BASE_URL + API_PATH;

export const LOGIN_URL = `${BACKEND_BASE_URL}o/token/`;
export const BACKEND_CLIENT_ID = 'it.tecnocreo.arsmartflow';
export const BACKEND_GRANT_TYPE = 'password';

export const PROJECTS_URL = `${BACKEND_BASE_URL}projects/`;
export const NODES_URL = `${BACKEND_BASE_URL}nodes/`;
export const DOCUMENTS_PATH = `documents/`;
export const MODELS_3D_PATH = `models_3d/`;
export const SCENES_3D_PATH = `scenes_3d/`;
export const SHARE_CODES_PATH = `share_codes/`;
export const CHANGE_NODE_STATUS_PATH = `change_status/`;
export const FORGOT_PASSWORD_PATH = `${BACKEND_BASE_URL}users/password-reset/`;
